// eslint-disable-next-line import/prefer-default-export
export const containerStyles = theme => ({
  '& > svg': {
    marginLeft: 0,
  },
  '&:last-child': {
    marginRight: 0,
  },
  backgroundColor: 'transparent',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '50px',
  margin: theme.spacing(0, 2, 3, 0),
});
